import { PageHeader, TenantsTable, useAuth } from "@nexys/user-management-web";
import { Navigate, useNavigate } from "react-router-dom";

export const TenantsPage = () => {
  const { hasUserRole } = useAuth();
  const navigate = useNavigate();
  if (!hasUserRole("superadmin")) return <Navigate to="/" replace />;

  return (
    <div className="grid gap-6">
      <PageHeader
        title="Tenants"
        description="Every organization on the server. Click one to manage its members."
      />
      <TenantsTable onSelect={(id) => navigate(`/tenants/${id}`)} />
    </div>
  );
};
